import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/tailwind.css";

// contexts
import { AuthProvider } from "contexts/AuthContext";
import { LanguageProvider } from "contexts/LanguageContext";

// layouts
import Admin from "layouts/Admin.js";
import Auth from "layouts/Auth.js";

// components
import ProtectedRoute from "components/ProtectedRoute.js";
import AdminRoute from "components/AdminRoute.js";
import PublicRoute from "components/PublicRoute.js";

// views without layouts
import Examples from "views/Examples.js";
import Landing from "views/Landing.js";
import GitHubAppGuide from "views/GitHubAppGuide.js";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <LanguageProvider>
    <AuthProvider>
      <BrowserRouter>
        <Switch>
          {/* Public landing page - redirects to dashboard if authenticated */}
          <Route path="/" exact render={() => (
            <PublicRoute>
              <Landing />
            </PublicRoute>
          )} />
          {/* Auth routes */}
          <Route path="/auth" component={Auth} />
          {/* Protected admin routes */}
          <Route path="/dashboard" exact render={() => (
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          )} />
          <Route path="/tasks" exact render={() => (
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          )} />
          <Route path="/projects" exact render={() => (
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          )} />
          <Route path="/plans" exact render={() => (
            <AdminRoute>
              <Admin />
            </AdminRoute>
          )} />
          <Route path="/users" exact render={() => (
            <AdminRoute>
              <Admin />
            </AdminRoute>
          )} />
          <Route path="/leads" exact render={() => (
            <AdminRoute>
              <Admin />
            </AdminRoute>
          )} />
          <Route path="/ai-models" exact render={() => (
            <AdminRoute>
              <Admin />
            </AdminRoute>
          )} />
          <Route path="/credits" exact render={() => (
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          )} />
          <Route path="/credit-analytics" exact render={() => (
            <AdminRoute>
              <Admin />
            </AdminRoute>
          )} />
          {/* Examples route - standalone page */}
          <Route path="/examples" exact component={Examples} />
          {/* GitHub App Guide - standalone page */}
          <Route path="/github-app-guide" exact component={GitHubAppGuide} />
          {/* Fallback redirect */}
          <Redirect from="*" to="/" />
        </Switch>
      </BrowserRouter>
    </AuthProvider>
  </LanguageProvider>
);
